import { createSelector } from 'reselect';
var selectNewspapersState = function (_a) {
    var newspapers = _a.newspapers;
    return newspapers;
};
/**
 * Selects the isFetching flag from the state
 */
export var newspapersStateLoadingSelector = createSelector(selectNewspapersState, function (_a) {
    var isFetching = _a.isFetching;
    return isFetching;
});
/**
 * Selects the possible error from the state
 */
export var newspapersStateErrorSelector = createSelector(selectNewspapersState, function (_a) {
    var didInvalidate = _a.didInvalidate, error = _a.error;
    return (didInvalidate ? error : false);
});
/**
 * Selects the entities of the state
 */
export var newspapersStateEntitiesSelector = createSelector(selectNewspapersState, function (_a) {
    var _b = _a.ids, ids = _b === void 0 ? [] : _b, _c = _a.entities, entities = _c === void 0 ? {} : _c;
    return ids.map(function (id) { return entities[id]; });
});
/**
 * Selects an entity by either its unique publication id (in case of daily view) or its unique date (in case of monthly view)
 */
export var newspapersStateEntityByIdSelector = function (publicationId, date) { return createSelector(selectNewspapersState, 
// We look for the correct entity directly on the entities' values, since when the entities are all from the same
// publication (i.e. in case of the monthly view), we cannot look for a single newspaper by publication id.
// Moreover, in that case the publicationId doesn't exist on the newspaper.
// In that case, only the datePublished is unique.
function (_a) {
    var _b = _a.entities, entities = _b === void 0 ? {} : _b;
    return Object.values(entities)
        .find(function (newspaper) { return newspaper.publicationId === publicationId || newspaper.datePublished === date; });
}); };
/**
 * Selects the entities of the state by date
 */
export var newspapersStateEntityByDateSelector = function (date) { return createSelector(selectNewspapersState, function (_a) {
    var _b = _a.entitiesByDate, entitiesByDate = _b === void 0 ? {} : _b, _c = _a.entities, entities = _c === void 0 ? {} : _c;
    if (entitiesByDate[date]) {
        return entitiesByDate[date].map(function (id) { return entities[id]; });
    }
    return [];
}); };
/**
 * Selects the dates existing in the newspaper state
 */
export var newspapersStateDatesSelector = createSelector(selectNewspapersState, function (_a) {
    var _b = _a.entitiesByDate, entitiesByDate = _b === void 0 ? [] : _b;
    return Object.keys(entitiesByDate);
});
/**
 * Compose previous selectors to return all the the relevant information
 * from the state
 */
export var newspapersStateSelector = createSelector(newspapersStateLoadingSelector, newspapersStateEntitiesSelector, newspapersStateErrorSelector, newspapersStateDatesSelector, function (loading, data, error, availableDates) { return ({ loading: loading, data: data, error: error, availableDates: availableDates }); });
/**
 * Compose previous selectors to return all the the relevant information
 * from the state, returning a single newspaper by string and publication id
 */
export var singleNewspaperStateSelector = function (publicationId, date) { return createSelector(newspapersStateLoadingSelector, newspapersStateEntityByIdSelector(publicationId, date), newspapersStateErrorSelector, function (loading, data, error) { return ({ loading: loading, data: data, error: error }); }); };
